import router from '@/router'

export default {
    updateAuthenticatedUser({ commit }, payload) {
        commit('UPDATE_AUTHENTICATED_USER', payload)
    },
    updateLoginGroup({ commit }, payload) {
        commit('UPDATE_LOGIN_GROUP', payload);
    }
}
